import React from "react";
import { Link } from "react-router-dom";

import Menu from "./Menu";
import Auth from "./Auth";
// import m4pLogo from "../img/m4pLogo.png";
import Logo from "../img/headerLogo.png";
import "../styles/header.css";

const style = {
  title: {
    display: "flex",
  },
  logo: {
    width: "50",
    height: "50",
  },
  menuBurger: {
    position: "fixed",
    right: "25px",
    top: "-25px",
    cursor: "pointer"
  },
  MenuTitle: {
    color: "white",
    position: "fixed",
    right: "80px",
  }
};

const Header = ({ user }) => {
  return (
    <header className="header">
      <Link to="/" style={style.logo}>
        <img src={Logo} alt="logo Speeker" height="40"/>
      </Link>

      {
        user 
          ? 
            (
              <div>
                <p style={style.MenuTitle}>Menu</p>
                <Menu user={user} style={style.menuBurger} />
              </div>
            ) 
          : <Auth />
      }
    </header>
  );
};

export default Header;
